/* eslint-disable import/no-extraneous-dependencies */
import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { setNotification } from 'state/actions'
import moment from 'moment'
import { isString } from 'lodash/lang'
import Calendar from 'react-datepicker'
import i18n from 'lib/i18n'
import 'react-datepicker/dist/react-datepicker.css'

const _ = i18n()
const date = (d) => d ? moment(d) : undefined
const isValidString = (s) => isString(s) && s.trim().length > 0

@connect((state) => ({locale: state.app.lang}), {setNotification})
export class DatePicker extends Component {
	onChange(date) {
		const { onChange } = this.props
		if (this.child && typeof this.child.hideCalendar === 'function') {
			this.child.hideCalendar() // hide the calendar after selecting a date
		}
		onChange(date ? date.format('YYYY-MM-DD') : '')
	}

	render() {
		const { value, locale, onBlur, onChange, onFocus, startDate, endDate, minDate, maxDate, setNotification, disabled, ...restProps } = this.props // eslint-disable-line no-unused-vars

		return (
			<Calendar
				{...{ moment, locale }}
				dateError={() => {
					let errorMessage = "dateFormatError"
					if (this.child.state.dateErrorMessage && this.child.state.dateErrorMessage.length > 0) {
						errorMessage = this.child.state.dateErrorMessage
					}
					setNotification(_(errorMessage), 'error')
				}}
				startDate={date(startDate)}
				endDate={date(endDate)}
				minDate={isValidString(minDate) ? moment(minDate) : moment().subtract(100, 'years')}
				maxDate={isValidString(maxDate) ? moment(maxDate) : moment().add(100, 'years')}
				isTypeable
                isClearable={!disabled}
                disabled={disabled}
				dateFormat="DD-MM-YYYY"
				placeholderText={_('datePicker')}
				selected={date(value)}
				showYearDropdown
				dateFormatCalendar="MMMM"
				onChange={this.onChange.bind(this)}
                {...restProps}
				ref={instance => {this.child = instance}}
			/>
		)
	}
}
DatePicker.propTypes = {
	value: PropTypes.any,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	locale: PropTypes.string,
	onFocus: PropTypes.func,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	minDate: PropTypes.string,
	maxDate: PropTypes.string,
	setNotification: PropTypes.func,
}



// WEBPACK FOOTER //
// ./components/shared/datePicker/DatePicker.jsx